import {useField} from "formik";
import Checkbox from "./Checkbox";

export function FormikCheckBox({name, label, field, afterOnChange}) {
    const [input, , handlers] = useField(name);

    const onChange = (value) => {
        const tmp = input.value;
        tmp[field] = value;
        handlers.setValue(tmp);
        if (afterOnChange) afterOnChange();
    };

    return (
        <Checkbox
            style={{marginBottom: 0}}
            checked={input.value[field]}
            onChange={onChange}
            label={label}
        />
    );
}
